import { type RouteRecordRaw } from "vue-router"
import { routes as AdsRoutes } from "./ads_standard"
import { routes as AffRoutes } from "./aff_standard"
import { routes as BreadRoutes } from "./bread_standard"
import { routes as ClarityPayRoutes } from "./claritypay_standard"
import { routes as FortivaRoutes } from "./fortiva_standard"
import { routes as GenesisRoutes } from "./genesis_standard"
import { routes as HFDRoutes } from "./hfd_standard"
import { routes as LendingClubRoutes } from "./lendingclub_standard"
import { routes as ProceedRoutes } from "./proceed_standard"
import { routes as SynchronyRoutes } from "./synchrony_standard"
import { routes as SnapRoutes } from "./snap_standard"

export const routes: RouteRecordRaw[] = [
  ...AdsRoutes,
  ...AffRoutes,
  ...BreadRoutes,
  ...ClarityPayRoutes,
  ...FortivaRoutes,
  ...GenesisRoutes,
  ...HFDRoutes,
  ...LendingClubRoutes,
  ...ProceedRoutes,
  ...SnapRoutes,
  ...SynchronyRoutes,
]
